module.exports = __webpack_public_path__ + "media/svg/download-icon-8e49a5b7.svg";